import { PMDonutChartCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { DashboardCardContext } from "../context";

export function addMaturityOfItemsCard(ctx: DashboardCardContext) {
  const { view, language, settings } = ctx;

  const dimensionFieldDefinition = settings?.configuration?.fieldsDefinition
    ?.filter((field) => field.purpose === "itemBasic")
    ?.find((field) => field.fieldName === "dimension");

  const configuredDimensionLabel =
    dimensionFieldDefinition?.label?.trim() ||
    getLocalizedMessage(language, "dimension") ||
    "Dimension";

  const getCompletionOfDimensionTitle = (
    currentLanguage: string,
    dimensionName?: string
  ) => {
    const baseTitle =
      getLocalizedMessage(
        currentLanguage,
        "cards.completionOfDimension.title",
        {
          dimensionLabel: configuredDimensionLabel,
        }
      ) || `Completion of ${configuredDimensionLabel}`;

    return dimensionName ? `${baseTitle} - ${dimensionName}` : baseTitle;
  };

  const maturityOfItemsComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "maturityOfItemsComponent",
      labels: ["donutChart", "chart", "maturity"],
      description:
        getLocalizedMessage(
          language,
          "cards.completionOfDimension.description",
          { dimensionLabel: configuredDimensionLabel }
        ) || "Distribution of activities by maturity",
      title: getCompletionOfDimensionTitle(language, undefined),
    },
  });

  maturityOfItemsComponent.mapLayoutProps(({ language }) => ({
    componentId: "maturityOfItemsComponent",
    labels: ["donutChart", "chart", "maturity"],
    title: getCompletionOfDimensionTitle(language, undefined),
    description:
      getLocalizedMessage(language, "cards.completionOfDimension.description", {
        dimensionLabel: configuredDimensionLabel,
      }) || "Distribution of activities by maturity",
  }));

  maturityOfItemsComponent.mapState(({ dashboard, settings, language }) => {
    const items =
      dashboard?.projects?.flatMap((project) => project.reportingItems ?? []) ??
      [];

    const maturityConfig = (
      settings?.configuration?.maturityConfiguration ?? []
    )
      .slice()
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    const data = maturityConfig.map((entry) => ({
      label: entry.name ?? "",
      value: items.filter(
        (item) => (item.basicItem?.maturity ?? "") === entry.name
      ).length,
      color: entry.color ?? "",
    }));

    return {
      title: getCompletionOfDimensionTitle(language, undefined),
      description:
        getLocalizedMessage(
          language,
          "cards.completionOfDimension.description",
          { dimensionLabel: configuredDimensionLabel }
        ) || "Distribution of activities by maturity",
      icon: "DonutLarge",
      data,
    };
  });

  maturityOfItemsComponent.mapVisibility(({ settings }) => {
    return settings?.configuration?.useCase === "maturity";
  });
}
